import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { automaticService } from "services";
import { logout } from "../logout";

export const getDevices = createAsyncThunk(
  "getDevices",
  async (
    {
      assemblyStatus,
      calibrationStatus,
      startDate,
      endDate,
      skip,
      limit,
      searchExpression,
      //deviceType is deprecated filter, it will be deleted when new dashboard is released
      deviceType,
      deviceTypes,
      packagingStatus,
      workOrders,
      deviceSerialNumberList,
    },
    { rejectWithValue }
  ) => {
    try {
      return await automaticService.get_devices(
        assemblyStatus,
        calibrationStatus,
        startDate,
        endDate,
        skip,
        limit,
        searchExpression,
        deviceType,
        deviceTypes,
        packagingStatus,
        workOrders,
        deviceSerialNumberList
      );
    } catch (error) {
      if (error.message) {
        if (error?.response?.status === 401) {
          logout();
        }
        //No response to request (No service)
        console.log("Internet Disconnected");
      } else {
        console.log(error);
        return rejectWithValue(error);
      }
    }
  }
);

const initialState = {
  result: null,
  loading: false,
  error: null,
};

const devicesSlice = createSlice({
  name: "devices",
  initialState: initialState,
  reducers: {
    clearDevicesList: (state, _action) => {
      state.result = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDevices.pending, (state, _action) => {
      state.loading = true;
    });
    builder.addCase(getDevices.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
      state.error = null;
    });
    builder.addCase(getDevices.rejected, (state, action) => {
      state.loading = false;
      state.result = null;
      state.error = action.payload;
    });
  },
});

export const { clearDevicesList } = devicesSlice.actions;
export default devicesSlice.reducer;
